export default __webpack_public_path__ + "static/media/Lasting Faith Gauntlets.70962cea.jpg";